import { ApiSuccessResponse, BaseSearchRequest } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  CrewMemberSearchResponse,
  Driver,
  DriverSearchResponse,
  DriverStatsResponse
} from "./@types";

export const driverApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDrivers: builder.mutation<
      ApiSuccessResponse<DriverSearchResponse>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/driver/drivers/search",
        method: "POST",
        body: { ...data },
      }),
    }),
    getCompanyDriverStats: builder.query<
      ApiSuccessResponse<DriverStatsResponse>,
      void
    >({
      query: () => ({
        url: "/driver/company-driver-stat",
        method: "GET",
      }),
    }),
    getFleetProDriverStats: builder.query<
      ApiSuccessResponse<DriverStatsResponse>,
      void
    >({
      query: () => ({
        url: "/driver/fleetpro-driver-stat",
        method: "GET",
      }),
    }),
    addDriver: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (data) => ({
        url: "/driver/driver",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateDriver: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/driver/drivers/${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    getDriverById: builder.query<ApiSuccessResponse<Driver>, string>({
      query: (id) => ({
        url: `/driver/drivers/${id}`,
        method: "GET",
      }),
    }),
    addCrewMember: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/crew",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateCrewMember: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/crew/search",
        method: "POST",
        body: { ...data },
      }),
    }),
    getCrewMembers: builder.mutation<
      ApiSuccessResponse<CrewMemberSearchResponse>,
      BaseSearchRequest
    >({
      query: (data) => ({
        url: "/v1/crew/search",
        method: "POST",
        body: { ...data },
      }),
    }),
    getCrewMemberById: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/crew/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetDriversMutation,
  useGetCompanyDriverStatsQuery,
  useGetFleetProDriverStatsQuery,
  useAddDriverMutation,
  useUpdateDriverMutation,
  useGetDriverByIdQuery,
  useAddCrewMemberMutation,
  useUpdateCrewMemberMutation,
  useGetCrewMembersMutation,
  useGetCrewMemberByIdQuery,
} = driverApiSlice;
